import React, { useEffect, useState } from 'react';
import { useHealthPlanContext } from '../../../../Services/HealthPlanContext';
import FullPageLoading from '../../../../Components/Utils/FullPageLoading/FullPageLoading';
import Text from '../../../../Components/Base/Text/Text';
import MagicForm from '../../../../Components/Form/MagicForm';
import { getCustomSchedule } from '../../../Monitoring/Services/monitoring.service';
import apiClient from '../../../../Services/ApiClient';
import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import moment from 'moment-timezone';
import { HealthPlanMonitoringBabyLatamTesting } from './HealthPlanMonitoringBabyLatamTesting';
import { useAppContext } from '../../../../Services/AppContext';
import { updateHealthPlanUserItem } from '../../Services/healthPlan.service';

interface Props {
	onSuccess: any;
}

const HealthPlanMonitoringTesting: React.FC<Props> = ({ onSuccess }) => {
	const [initialized, setInitialized] = useState(false);
	const { healthPlanUser, activeHealthPlanUserItem } = useHealthPlanContext();
	const [formScheme, setFormScheme] = useState<ItemScheme[]>();
	const approxDeliveryIn = 20 + (5 - (moment().minutes() % 5));
	const { globalTemplate } = useAppContext();

	const defaultData = {
		meddiBabyLatamVaginalBleeding: {
			toggle: true,
		},
		meddiBabyLatamTemperature: {
			toggle: true,
		},
		meddiBabyLatamWeight: {
			toggle: true,
		},
		meddiBabyLatamUrinaryTractInfection: {
			toggle: true,
		},
		meddiBabyLatamVaginalInfection: {
			toggle: true,
		},
		meddiBabyLatamVomiting: {
			toggle: true,
		},
		meddiBabyLatamDiarrhoea: {
			toggle: true,
		},
		meddiBabyLatamSwelling: {
			toggle: true,
		},
		meddiBabyLatamMedicaments: {
			toggle: true,
		},
		meddiBabyLatamBloodpresure: {
			toggle: true,
		},
		meddiBabyLatamGlycemia: {
			toggle: true,
		},
		meddiBabyLatamAmnioticFluidLeak: {
			toggle: true,
		},
		meddiBabyLatamHypertensionSymptoms: {
			toggle: true,
		},
		meddiBabyLatamBreastSelfAssessment: {
			toggle: true,
		},
		meddiBabyLatamUterineContractions: {
			toggle: true,
		},
		meddiBabyLatamFetalMovements: {
			toggle: true,
		},
		meddiBabyLatamLochia: {
			toggle: true,
		},
		meddiBabyLatamLowerAbdomenPain: {
			toggle: true,
		},
		meddiBabyLatamRouteOfDelivery: {
			toggle: true,
		},
	};

	const ranks: any = {
		meddiBabyLatamVaginalBleeding: 0,
		meddiBabyLatamTemperature: 1,
		meddiBabyLatamWeight: 2,
		meddiBabyLatamUrinaryTractInfection: 3,
		meddiBabyLatamVaginalInfection: 4,
		meddiBabyLatamVomiting: 5,
		meddiBabyLatamDiarrhoea: 6,
		meddiBabyLatamSwelling: 7,
		meddiBabyLatamMedicaments: 8,
		meddiBabyLatamBloodpresure: 9,
		meddiBabyLatamGlycemia: 10,
		meddiBabyLatamHypertensionSymptoms: 11,
		meddiBabyLatamAmnioticFluidLeak: 12,
		meddiBabyLatamFetalMovements: 13,
		meddiBabyLatamUterineContractions: 14,
		meddiBabyLatamLochia: 15,
		meddiBabyLatamLowerAbdomenPain: 16,
		meddiBabyLatamRouteOfDelivery: 17,
		meddiBabyLatamBreastSelfAssessment: 18,
	};

	useEffect(() => {
		setFormScheme(HealthPlanMonitoringBabyLatamTesting);
		setInitialized(true);
	}, []);

	const handleSave = async (values: any) => {
		const dataToSend = values;
		for (const key of Object.keys(dataToSend)) {
			const addMinutes = 20 + (5 - (moment().minutes() % 5));

			let customTime = moment().add(addMinutes, 'minutes');

			let simulateTimezone = undefined;
			switch (globalTemplate) {
				case 'peru':
					simulateTimezone = 'America/Lima';
					break;
				case 'ecuador':
					simulateTimezone = 'America/Guayaquil';
					break;
				case 'mexico':
					simulateTimezone = 'Mexico/General';
					break;
				case 'colombia':
					simulateTimezone = 'America/Bogota';
					break;
			}

			if (simulateTimezone) {
				let hours =
					Math.abs(
						moment().tz(simulateTimezone).utcOffset() -
							moment()
								.tz(Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone)
								.utcOffset(),
					) / 60;

				customTime = moment()
					.subtract(hours, 'hours')
					.add(addMinutes, 'minutes');
			}

			const customSending = [
				{
					customTime: customTime,
					customDayOfWeek: {
						value: moment().day(),
					},
				},
			];
			dataToSend[key].customSchedule = getCustomSchedule(customSending);
			dataToSend[key].frequency = 'custom';
			dataToSend[key].questionnaireCode = key;
			dataToSend[key].rank = ranks[key];
		}

		if (healthPlanUser?.healthPlanId && activeHealthPlanUserItem?.id) {
			await updateHealthPlanUserItem({
				healthPlanId: healthPlanUser.healthPlanId,
				healthPlanUserId: healthPlanUser.id,
				healthPlanItemId: activeHealthPlanUserItem.id,
				data: {
					extra: {
						data: dataToSend,
					},
				},
			});
			onSuccess?.();
		}
	};

	if (!initialized) {
		return <FullPageLoading />;
	}

	return (
		initialized && (
			<>
				<Text className='danger-text mb-4'>
					{'---- POZOR! TOTO JE TESTOVACÍ ODESÍLÁNÍ ZVOLENÉ DOTAZNÍKY BUDOU DORUČENY ZA cca ' +
						approxDeliveryIn +
						' MINUT ----'}
				</Text>
				{formScheme && (
					<MagicForm
						formScheme={formScheme}
						onSubmit={handleSave}
						defaultValues={defaultData}
					/>
				)}
			</>
		)
	);
};

export default HealthPlanMonitoringTesting;
